import { NavButtonsContainer } from "@src/common/styled-components";
import { APP_ROUTES, OPTUM_BH_HOME_URL } from "@src/constants";
import { useApplicationContext } from "@src/context/ApplicationContext";
import { useTimerContext } from "@src/context/TimerContext";
import { useExclusiveAction } from "@src/hooks/useExclusiveAction";
import { useNavigateWithUTM } from "@src/hooks/useNavigateWithUTM";
import { useLocation } from "@uhg-abyss/web/tools/reactRouterTools";
import { Button } from "@uhg-abyss/web/ui/Button";

export const NavButtons = ({ isMobile }) => {
  const { clearSession, completedRoutes } = useApplicationContext();
  const { isTimerRunning, stopTimer } = useTimerContext();
  const navigate = useNavigateWithUTM();
  const { isPending, isUiBlocked } = useExclusiveAction("get-started:next");
  const location = useLocation();
  const referPath = location.state?.referPath || APP_ROUTES.REFER;
  const isMeetTheTeamOrigin = completedRoutes[APP_ROUTES.MEET_THE_TEAM] === true;

  return (
    <NavButtonsContainer isMobile={isMobile}>
      <Button
        {...(!isMobile && {
          icon: {
            icon: "chevron_left",
            position: "leading",
            variant: "outlined",
          },
        })}
        id="obc-get-started-form-back-btn"
        data-testid="test-id-get-started-back-button"
        data-obc-label="Get Started Form Back Button"
        onClick={() => {
          clearSession();
          if (completedRoutes[APP_ROUTES.REFER] === true) {
            return navigate(referPath);
          } else if (isMeetTheTeamOrigin) {
            return navigate(APP_ROUTES.MEET_THE_TEAM);
          } else {
            if (isTimerRunning) stopTimer();
            window.location.href = OPTUM_BH_HOME_URL;
          }
        }}
        variant={isMobile ? "text" : "outline"}
        size={isMobile ? "lg" : "md"}
      >
        Back
      </Button>
      <Button
        css={isMobile && { width: "100%" }}
        icon={
          !isMobile
            ? {
                icon: "chevron_right",
                position: "trailing",
                variant: "outlined",
              }
            : undefined
        }
        size={isMobile ? "lg" : "md"}
        variant="filled"
        type="submit"
        form="get-started-form"
        id="obc-get-started-form-next-btn"
        data-testid="test-id-get-started-next-button"
        data-obc-label="Get Started Form Next Button"
        isDisabled={isPending || isUiBlocked}
      >
        Next
      </Button>
    </NavButtonsContainer>
  );
};
